'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _loginTrigger = require('../../auth/login-trigger');

var _loginTrigger2 = _interopRequireDefault(_loginTrigger);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// TODO: Is there a way to extend the TopBarMenuLink component so that we don't
// have to duplicate the class designations?

var LogInButton = _react2['default'].createClass({
    displayName: 'LogInButton',


    propTypes: {
        'googleOpenIdUrl': _react2['default'].PropTypes.string.isRequired,
        'useWhite': _react2['default'].PropTypes.bool,
        'useBlack': _react2['default'].PropTypes.bool,
        'isMobile': _react2['default'].PropTypes.bool,
        'isCompact': _react2['default'].PropTypes.bool,
        'emailAddress': _react2['default'].PropTypes.string,
        'loginUrl': _react2['default'].PropTypes.string,
        'useRegularLink': _react2['default'].PropTypes.bool,
        'headerText': _react2['default'].PropTypes.string,
        'recaptchaPublicKey': _react2['default'].PropTypes.string,
        'displayCaptcha': _react2['default'].PropTypes.bool,
        'className': _react2['default'].PropTypes.string,
        'recoverPasswordForm': _react2['default'].PropTypes.object.isRequired, // Serialized sfForm
        'loginForm': _react2['default'].PropTypes.object.isRequired // Serialized sfForm
    },

    getInitialState: function getInitialState() {
        return {
            'useWhite': false
        };
    },

    getDefaultProps: function getDefaultProps() {
        return {
            'headerText': 'Welcome back'
        };
    },

    render: function render() {
        var classSet = (0, _classnames2['default'])({
            'm-link-list--link': !this.props.isMobile,
            'm-link-list--log-in': !this.props.isMobile,
            'm-link-list--link-break-2': !this.props.isMobile,
            'm-mobile-menu--signin-link': this.props.isMobile,
            'is-compact': !this.props.isMobile && this.props.isCompact,
            'c-white': this.props.useWhite,
            'hc-warm-chinchilla': this.props.useWhite,
            'c-ashen': this.props.useBlack || !this.props.useWhite,
            'hc-cerulean': !this.props.useWhite
        });

        if (this.props.className) {
            classSet += " " + this.props.className;
        }

        var trigger = _jsx('div', {
            className: 'm-link-list--link--container'
        }, void 0, _jsx('a', {
            className: classSet,
            href: this.props.useRegularLink ? this.props.loginUrl : 'javascript:;',
            tabIndex: '-1'
        }, void 0, 'Log In'));

        if (this.props.useRegularLink) {
            var returnValue = trigger;
        } else {
            var returnValue = _jsx(_loginTrigger2['default'], {
                trigger: trigger,
                header: this.props.headerText,
                buttonText: 'Sign In',
                recaptchaPublicKey: this.props.recaptchaPublicKey,
                displayCaptcha: this.props.displayCaptcha,
                googleOpenIdUrl: this.props.googleOpenIdUrl,
                emailAddress: this.props.emailAddress,
                loginUrl: this.props.loginUrl,
                recoverPasswordForm: this.props.recoverPasswordForm,
                loginForm: this.props.loginForm
            }, void 0);
        }
        return returnValue;
    }
});

module.exports = LogInButton;


/*****************
 ** WEBPACK FOOTER
 ** ./src/hellosign/components/home/top-bar-menu/login-button.jsx
 ** module id = 766
 ** module chunks = 0
 **/